const PREFIX = "link/exchange/";

const apiList = {
  getLink: PREFIX + "getUrl",
};

export { apiList };
